export default {"src":"/_next/static/media/male-profile.f353935b.svg","height":400,"width":400,"blurWidth":0,"blurHeight":0};